// extracted by mini-css-extract-plugin
module.exports = {"contents":"rh","sectionHeading":"sh"};